import { modes } from '@/utils/types'
import style from './css'

const BamboraEcommerceV2 = {
  label: 'Demo-eCommerce Custom Template Example',
  includeInShowcase: true,
  config: {
    userId: 'PayTestSE',
    merchantId: 1014,
    mode: modes.ECOMMERCE,
    amount: 1499,
    scrollToOffset: 8,
    showAccounts: 'inline',
    showFooter: false,
    globalSubmit: true,
    showListHeaders: true,
    containerWidth: '600px',
    containerHeight: '850px',
    saveAccountOption: true
  },
  theme: {
    buttons: {
      color: '#000000'
    },
    labels: {
      color: '#1e1e1e',
      fontSize: '12px'
    },
    headings: {
      color: '#1e1e1e',
      fontSize: '14px'
    },
    loader: {
      color: '#29b355'
    },
    input: {
      color: '#1e1e1e',
      height: '52px'
    },
    headerbackground: {
      color: '#ffffff'
    },
    cardbackground: {
      color: '#ffffff'
    }
  },
  style
}

export default BamboraEcommerceV2
